export { HomeTemplate } from './HomeTemplate';
export type { HomeTemplateProps, CategoryItem } from './HomeTemplate.types';
